import { createContext } from 'react';
import * as _ from 'lodash';
import type { DependencyInfoOption } from '../../shared/types';

type Context = {
  dependencyInfoOptions: DependencyInfoOption[];
  setDependencyInfoOptions: (options: DependencyInfoOption[]) => void;
};

export const ReportContainerContext = createContext<Context>({
  dependencyInfoOptions: [],
  setDependencyInfoOptions: _.noop,
});

export const Provider = ReportContainerContext.Provider;
